import React, { useState, useEffect } from 'react';

const CatalogSelector = ({ isOpen, onClose, onSelect, equipmentText }) => {
  const [catalog, setCatalog] = useState([]);
  const [filteredCatalog, setFilteredCatalog] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      loadCatalog();
    }
  }, [isOpen]);

  useEffect(() => {
    if (searchTerm) {
      setFilteredCatalog(
        catalog.filter(item => 
          item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.ref.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredCatalog(catalog);
    }
  }, [searchTerm, catalog]);

  const loadCatalog = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://api.aimycore.fr/api/analyze/catalog');
      if (response.ok) {
        const catalogData = await response.json();
        setCatalog(catalogData);
        setFilteredCatalog(catalogData);
      } else {
        console.error('Erreur chargement catalogue:', response.status);
      }
    } catch (error) {
      console.error('Erreur chargement catalogue:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleItemSelection = (item) => {
    setSelectedItems(prev => {
      const isSelected = prev.find(selected => selected.ref === item.ref);
      if (isSelected) {
        return prev.filter(selected => selected.ref !== item.ref);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleSubmit = () => {
    onSelect(selectedItems);
    setSelectedItems([]);
    setSearchTerm('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        width: '800px',
        height: '600px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h3 style={{ marginTop: 0 }}>
          Sélectionner des alternatives pour : <strong>{equipmentText}</strong>
        </h3>

        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            placeholder="Rechercher dans le catalogue (marque, référence, type...)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '14px'
            }}
          />
        </div>

        {selectedItems.length > 0 && (
          <div style={{ marginBottom: '16px', padding: '8px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
            <strong>Sélectionnés ({selectedItems.length}) :</strong>
            {selectedItems.map(item => (
              <span key={item.ref} style={{
                display: 'inline-block',
                margin: '2px',
                padding: '2px 6px',
                backgroundColor: '#2563eb',
                color: 'white',
                borderRadius: '3px',
                fontSize: '12px'
              }}>
                {item.ref}
              </span>
            ))}
          </div>
        )}

        <div style={{
          flex: 1,
          overflowY: 'auto',
          border: '1px solid #d1d5db',
          borderRadius: '4px'
        }}>
          {loading ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>Chargement du catalogue L&DB...</div>
          ) : (
            <div>
              {filteredCatalog.map(item => {
                const isSelected = selectedItems.find(selected => selected.ref === item.ref);
                return (
                  <div
                    key={item.ref}
                    onClick={() => toggleItemSelection(item)}
                    style={{
                      padding: '8px 12px',
                      borderBottom: '1px solid #f3f4f6',
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#dbeafe' : 'white',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <strong>{item.ref}</strong> - {item.label}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {item.price_eur_ht_day}€/j
                    </div>
                    {isSelected && (
                      <div style={{ marginLeft: '8px', color: '#2563eb' }}>✓</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button
            onClick={handleSubmit}
            disabled={selectedItems.length === 0}
            style={{
              padding: '8px 16px',
              backgroundColor: selectedItems.length > 0 ? '#059669' : '#9ca3af',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: selectedItems.length > 0 ? 'pointer' : 'not-allowed'
            }}
          >
            Confirmer la sélection ({selectedItems.length})
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatalogSelector;
